import { Component, Input, Output, EventEmitter} from '@angular/core'

@Component({
  selector: 'app-st-button-sort-text-asc',
  templateUrl: './st-button-sort-text-asc.component.html',
  styleUrls: ['./st-button-sort-text-asc.component.scss'],
  standalone: false
})
export class StButtonSortTextAscComponent {

  @Input()
  idVal: string = 'buttonId';

  @Input()
  primary = false;

  @Input()
  label = 'Button';

  @Input()
  width?: string;

  @Input()
  backgroundColor: string = '#ffffff';

  @Input()
  fontColor: string = '#000000'

  @Output()
  onClick = new EventEmitter<Event>();

  public get classes(): string[] {
    const mode = this.primary ? 'st-button-primary' : 'st-button-secondary';

    return ['st-button', mode];
  }
}
